export enum ContactEmailFlag {    
    ReceiveMatchOffers = 1,
    ReceiveCommenceXm = 2,
    ReceiveCancelSwap = 3,
    ReceiveDefaultEmail = 4,
    ReceiveScheduleLogisticsCall = 5,
    ReceiveScheduleKickoffCall = 6,
    ReceiveLateForLogisticsCall = 7,
    ReceiveLateForKickoffCall = 8,
    ReceiveMoDeadlinePending = 9,
    ReceiveXmDeadlinePending = 10,
    ReceiveMoDeadlineMissed = 11,
    ReceiveXmDeadlineMissed = 12,
    ReceiveMoDecisionConfirm = 13,
    ReceiveXmDecisionConfirm = 14,
    ReceiveOrganPickupConfirm = 15,
    ReceiveOrganDeliveryConfirm = 16,
    ReceiveBmEmailMoUpload = 17,
    ReceiveRequestDonorInfo = 18,
    ReceiveDonorSurveillance = 19,
    ReceivePostTransplantReminders = 20,
    ReceiveDataCompliancePairs = 21,
    ReceiveXmReqExploratory = 22,
    ReceiveXmReqFinal = 23,
    ReceiveXmReqScreening = 24,
    ReceiveXmKitShipped = 25,
    ReceiveXmBloodShipped = 26,
    ReceiveXmBloodReceived = 27,
    ReceiveXmRecorded = 28,
    ReceiveNddCertReminder = 29,
    ReceiveNddSelfRegistered = 30,
    ReceiveNddRegistered = 31,
    ReceiveNddExportable = 32,
    ReceiveContactUsCenter = 33,
    ReceiveContactUsDonor = 34,
    ReceiveContactUsMedia = 35,
    ReceiveContactUsRecipient = 36,
    ReceiveContactUsOther = 37,
    ReceivePatientReferral = 38,
    ReceiveFinancialDonations = 39,
    ReceiveLWRApplicationApproved = 40,
    ReceiveLWRDeclinedFixable = 41, 
    ReceiveDERApplicationApproved = 42, 
    ReceiveDERDeclinedFixable = 43,
    ReceiveLWRPaymentProcessed = 44,
    ReceiveDERPaymentProcessed = 45,
    ReceiveAdditionalWeeksApproved = 46
}